import { VNode, createVNode, render } from "vue";
import EnterChangeDialog from "./index.vue";

const getDivElement = () => {
    return document.createElement("div");
};

const vmMap = new Map();

export let currentContainer = undefined as unknown;

const setComponentToBody = () => {
    const container = (currentContainer = getDivElement());
    const vm: VNode = createVNode(EnterChangeDialog);
    const appendTo: HTMLElement = document.body;
    render(vm, container);
    appendTo.appendChild(container.firstElementChild as Node);
    return vm;
};

const enterChangeDialog = () => {
    return new Promise((resolve, reject) => {
        const vm = setComponentToBody();
        vmMap.set(vm, { resolve, reject });
    });
};

export default enterChangeDialog;
